import O1HD from "../../engines/gameEngine";

export enum BUNDLE_SMALL_NAME{
    animationGameBundle = "animalModeGameBundle",
    normalMode = "normalMode",
    gameBundle = "gameBundle",
    auctionGameBundle = "auctionGameBundle",
    backPackGameBundle = "backpackGameBundle",
    digitalChallengeGameBundle = "digitalChallengeGameBundle",
    examinationGameBundle = "ExaminationGameBundle",
    clamShellGameBundle = "clamShellGameBundle",
    garbagGameBundle = "garbagGameBundle",
    siteGameBundle = "siteGameBundle",
    farmGameBundle = "farmGameBundle",
    mineLandGameBundle = "mineLandGameBundle",
    shopGameBundle = "shopGameBundle",
    stockGameBundle = "stockGameBundle",
    treasureHuntGameBundle = "treasureHuntGameBundle",
    WeChatGameBundle = "WeChatGameBundle",
    parkBundle = "parkBundle",
    talentMarketBundle = "talentMarketBundle",
    recreationClubBundle = "recreationClubBundle",
    lotteryGameBundle = "lotteryGameBundle",
    lotteryBundle = "lotteryBundle",
    militaryBundle = "militaryBundle",
    palaceBundle = "palaceBundle",
    mansionBundle = "mansionBundle",
    lakeGameBundle = "lakeGameBundle",
    setUpShopGameBundle = "setUpShopGameBundle",
    rankGameBundle = "rankGameBundle",
    openOreGameBundle = "openOreGameBundle",
    marketGameBundle = "marketGameBundle",
    cooperativeGameBundle = "cooperativeGameBundle",
    stallGameBundle = "stallGameBundle",
    chickenBundle = "chickenGameBundle",
    investStockGameBundle = "investStockGameBundle",
    phoneGameBundle = "phoneGameBundle",
    eventGameBundle = "eventGameBundle",
    loveStroyGameBundle = "loveStoryGameBundle",
    bannerGameBundle = "bannerGameBundle",
    settleLawsuitBundle = "settleLawsuitBundle",
	pawnShopGameBundle = "pawnShopGameBundle",
	matchMiaiBundle = "matchMiaiBundle",
    examBundle = "examBundle",
    localMagic = "localMagic",
    waterCourse = "watercourseGameBundle",
    superPowerBundle = "superPowerBundle",
    thruTimeAccess = "thruTimeAccess",
    touchCardBundle = "touchCardBundle",
    takeCow = "takeCowGameBundle",
    archeryArrow = "archeryGameBundle",
    antiphonalVerse = "antiphonalVerseGameBundle",
    boastGuiFei = "boastGuiFei",
    guiFeiBundle = "guiFeiBundle",
    hitRobBundle = "hitRobBundle",
    dartGameBundle = "dartGameBundle",
    escortGoods1Bundle = "escortGoods1Bundle",
    taskBundle = "taskBundle",
    gamblerGameBundle = "gamblerGameBundle",
    kaogu = "kaogu",
    oilfield = "oilfield",
    fddsMode = "fddsMode",
    skipPlotBundle = "skipPlotBundle",
    codeBreakGameBundle = "codeBreakingGameBundle",
    orchardBundle = "orchardBundle",
    chooseConcubineGameBundle = "chooseConcubineGameBundle",
}

export default async function getOneBundle(bundleName:BUNDLE_SMALL_NAME,isShowLoding:boolean = true):Promise<cc.AssetManager.Bundle>{
    return new Promise<cc.AssetManager.Bundle>(async resolve=>{
        let bundle = cc.assetManager.getBundle(bundleName);
        if(bundle){
            resolve(bundle);
        }else{
            if(isShowLoding){
                await O1HD.getModules().uiControlModule.showLoading();
            }
            cc.assetManager.loadBundle(bundleName,cc.AssetManager.Bundle,(err,asset:cc.AssetManager.Bundle)=>{
                if(err){
                    console.log("加载bundle失败",err);
                    resolve(null);
                }else{
                    resolve(asset);
                }
                if(isShowLoding){
                    O1HD.getModules().uiControlModule.hideLoading();
                }
            });
        }
    });
}

export async function getOneBundleOnePrefab(
    bundleName: BUNDLE_SMALL_NAME
    , prefabUrl:string
    , bShowLoad: boolean = true
) {
    if (bShowLoad) {
        await O1HD.getModules().uiControlModule.showLoading();
    }
    let bundle = await getOneBundle(bundleName,false);
    return new Promise<cc.Prefab>(resolve=>{
        if(bundle){
            bundle.load(prefabUrl,cc.Prefab,(err,prefab:cc.Prefab)=>{
                if(err){
                    console.log(err);
                    resolve(null);
                }else{
                    resolve(prefab);
                }
            });
            if (bShowLoad) {
                O1HD.getModules().uiControlModule.hideLoading();    
            }
        }else{
            if (bShowLoad) {
                O1HD.getModules().uiControlModule.hideLoading();
            }
            resolve(null);
        }
    })
}

export function getOneBundleByInstant(bundleName:BUNDLE_SMALL_NAME){
    return cc.assetManager.getBundle(bundleName);
}
